/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'efb-lang-switch',
  styleUrl: 'lang-switch.scss',
  shadow: true,
})
export class EfbLangSwitch {
  @Prop() href: string;

  @Prop() text: string;

  @Prop() compact?: boolean;

  render() {
    return (
      <Host>
        <a href={this.href} class={`lang-switch ${this.compact ? 'is-compact' : ''}`}>
          {this.text}
        </a>
      </Host>
    );
  }
}
